{
  "configurationModal": {
    "title": "Créer une nouvelle configuration de page d'accueil",
    "name": "Nom de la configuration"
  },
  "editHomePageModal": {
    "title": "Modifier la page d'accueil",
    "name": "Nom de la page",
    "save": "Enregistrer"
  },
  "editor": {
    "description": "Configurez les widgets et le contenu pour cette mise en page de page d'accueil.",
    "saveChanges": "Enregistrer les modifications",
    "delete": "Supprimer la configuration",
    "addWidget": "Ajouter un widget",
    "edit": "Modifier",
    "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer cette configuration de page d'accueil ? Cette action ne peut pas être annulée."
  },
  "widget": {
    "addWidget": "Ajouter un widget de page d'accueil",
    "editWidget": "Modifier le widget",
    "options": "Options du widget",
    "noWidgets": "Aucun widget configuré. Ajoutez un widget pour commencer.",
    "freeFormInput": {
      "title": "Contenu libre",
      "description": "Ajoutez du contenu personnalisé, du texte et des médias à votre page d'accueil"
    }
  },
  "practiceOverview": {
    "totalAum": "Total des actifs sous gestion",
    "averageAum": "Moyenne des actifs sous gestion/Client",
    "totalClients": "Nombre total de clients",
    "netflows": "Flux nets",
    "managementFees": "Frais de gestion",
    "fundedClients": "Nombre de clients financés",
    "cashPercentage": "Pourcentage de liquidités",
    "fromLastMonth": "du mois dernier"
  },
  "welcome": "Bienvenue",
  "other": "Autre",
  "aumExplorer": {
    "accountType": "Type de compte",
    "modelPortfolio": "Portefeuille modèle",
    "childOrganization": "Organisation enfant",
    "repCode": "Code de représentant",
    "noData": "Aucune donnée disponible"
  },
  "feesAndRevenue": {
    "noFeesCollectedYet": "Aucuns frais perçus pour l'instant",
    "timeFrame": {
      "1Y": "1A",
      "YTD": "AAJ"
    }
  },
  "report": {
    "filter": {
      "any": "Tout",
      "individual": "Individuel",
      "nonIndividual": "Non individuel"
    }
  },
  "productAumExposure": {
    "security": "Titre",
    "selectSecurity": "Sélectionnez un titre pour afficher les classements d'exposition.",
    "noResults": "Aucun client ne détient ce titre.",
    "summary": "L'exposition totale à {{productName}} ({{ticker}}) est de {{totalMarketValue}}. Cette exposition est répartie sur {{count}} {{levelLabel}}. Voici la liste classée par exposition :",
    "exposureLevels": {
      "HOUSEHOLD_one": "ménage",
      "HOUSEHOLD_other": "ménages",
      "ENTITY_one": "entité",
      "ENTITY_other": "entités",
      "ACCOUNT_one": "compte",
      "ACCOUNT_other": "comptes"
    },
    "exportFileName": "Exposition_AUM_Produit",
    "exportProgressTitle": "Exportation de l'exposition AUM du produit",
    "columns": {
      "rank": "Rang",
      "householdName": "Ménage",
      "entityName": "Entité",
      "firstName": "Prénom",
      "lastName": "Nom de famille",
      "accountName": "Compte",
      "accountType": "Type de compte",
      "accountNumber": "Numéro de compte",
      "marketValue": "Valeur marchande"
    }
  }
}
